import { render, staticRenderFns } from "./RegisterOnboarding.vue?vue&type=template&id=0cb7d918&scoped=true&"
import script from "./RegisterOnboarding.vue?vue&type=script&lang=js&"
export * from "./RegisterOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./RegisterOnboarding.vue?vue&type=style&index=0&id=0cb7d918&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb7d918",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCardTitle,VImg})
